import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const ChevronDown = ({
  size,
  type,
  theme,
  className,
  dataTestId = "chevron-down-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.24116 5.69136C3.50151 5.43101 3.92362 5.43101 4.18397 5.69136L8.00035 9.50773L11.8167 5.69136C12.0771 5.43101 12.4992 5.43101 12.7595 5.69136C13.0199 5.95171 13.0199 6.37382 12.7595 6.63416L8.47175 10.9219C8.2114 11.1823 7.78929 11.1823 7.52894 10.9219L3.24116 6.63416C2.98081 6.37382 2.98081 5.95171 3.24116 5.69136Z"
    />
  </SVGIcon>
);
